"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "montepaone": {
    "e3159dc4": [{
      "hkey": "5b009ee1",
      "slug": "paparo-sant-angelo-timporello",
      "name": "Paparo-Sant'Angelo-Timporello",
      "primary": true,
      "skipSearch": false
    }],
    "timponello": [{
      "hkey": "5b009ee1",
      "slug": "paparo-sant-angelo-timporello",
      "name": "Paparo-Sant'Angelo-Timporello",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;